/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React from "react";
import Spinner from "components/jiffy/react-cart/Spinner.vue";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import { cn } from "tailwind-variants";
import { renderList } from "common/vue/render-list";
import "./DtfSpangleVersions.scss";

// @ts-expect-error TS(7031): Binding element 'externalClassName' implicitly has... Remove this comment to see the full error message
export default function DtfSpangleVersions({ className: externalClassName, ...restProps }) {
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();

  function artworkBackground() {
    // @ts-expect-error TS(4111): Property 'artworkBackground' comes from an index s... Remove this comment to see the full error message
    return store.artworkBackground;
  }

  function selectedAlgorithm() {
    // @ts-expect-error TS(4111): Property 'selectedAlgorithm' comes from an index s... Remove this comment to see the full error message
    return spanglesStore.selectedAlgorithm;
  }

  function spangleVariations() {
    // @ts-expect-error TS(4111): Property 'spangleVariations' comes from an index s... Remove this comment to see the full error message
    return spanglesStore.spangleVariations;
  }

  function isTransparent() {
    return artworkBackground() === "transparent";
  }

  function validVersions() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return spangleVariations().filter((version: any) => !version.error);
  }

  function selectVersion(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return spanglesStore.selectVersion(...args);
  }

  function versionLoaderText(version: any) {
    if (version.error) return "Error loading pattern";
    return "Version in progress...";
  }

  return (
    <>
      {validVersions().length ? (
        <div
          {...restProps}
          className={cn("spangle-versions scope-225a879f", externalClassName)}
          style={{
            // @ts-expect-error TS(2322): Type '{ "--225a879f-artworkBackground": unknown; }... Remove this comment to see the full error message
            "--225a879f-artworkBackground": artworkBackground()
          }}
        >
          <div className="spangle-versions__header scope-225a879f">Select fill</div>
          <div className="spangle-versions__versions-container scope-225a879f">
            {renderList(validVersions(), (version, index) => (
              <div
                className={cn(
                  "spangle-versions__version scope-225a879f",
                  validVersions().length > 2 && "spangle-versions__version--small",
                  selectedAlgorithm() === version.algorithm &&
                    "spangle-versions__version--selected",
                  (version.isLoading || version.error) && "spangle-versions__version--placeholder"
                )}
                key={version.algorithm}
                onClick={() => {
                  selectVersion({
                    version
                  });
                }}
                data-testid="spangle-versions-version"
              >
                {version.isLoading || version.error ? (
                  <>
                    {version.isLoading ? (
                      <Spinner
                        className="spangle-versions__version-loader scope-225a879f"
                        data-testid="spangle-versions-version-loader"
                      />
                    ) : version.error ? (
                      <UseSvg
                        className="spangle-versions__version-error scope-225a879f"
                        icon="strong-info"
                        data-testid="spangle-versions-version-error"
                      />
                    ) : null}
                    <div className="spangle-versions__version-text scope-225a879f">
                      {versionLoaderText(version)}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="spangle-versions__version-text scope-225a879f">
                      Pattern {index + 1}
                    </div>
                    <div
                      className={cn(
                        "spangle-versions__version-background scope-225a879f",
                        isTransparent() && "spangle-versions__version-background-transparent"
                      )}
                    >
                      <img
                        className="spangle-versions__version-image scope-225a879f"
                        src={version.imageUrl}
                        alt={`Spangle Pattern : ${index + 1}`}
                      />
                    </div>
                    <div className="spangle-versions__version-preview-text scope-225a879f">
                      Preview
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
}
